class DuoField extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.handleClick);
  }

  updateAttributes(duoField, index) {
    const inputs = duoField.querySelectorAll("input");
    inputs.forEach((input) => {
      // update name
      let name = input.getAttribute("name");
      const nameParts = name.split("[");
      const baseName = nameParts[1].split("]")[0].replace(/\s[0-9]*$/, "");
      const newName = `contact[${baseName} ${index + 1}]`;
      input.setAttribute("name", newName);

      // update id
      let id = input.id;
      const baseId = id.replace(/-[0-9]*$/, "");
      const newId = `${baseId}-${index + 1}`;
      input.setAttribute("id", newId);

      // update autocomplete
      let autocomplete = input.getAttribute("autocomplete");
      const baseAutocomplete = autocomplete.replace(/\s[0-9]*$/, "");
      const newAutocomplete = `${baseAutocomplete} ${index + 1}`;
      input.setAttribute("autocomplete", newAutocomplete);
    });
  }

  updateAllAttributes() {
    const duoFields = document.querySelectorAll(
      `.duo-field[data-id="${this.dataset.id}"]`
    );
    duoFields.forEach((duoField, index) => {
      this.updateAttributes(duoField, index);

      // Get the remove button in the duo field
      const removeButton = duoField.querySelector(".remove");
      if (removeButton) {
        // If there's only one duo field, add the 'hidden' class to the remove button
        // Otherwise, remove the 'hidden' class
        if (duoFields.length === 1) {
          removeButton.classList.add("hidden");
        } else {
          removeButton.classList.remove("hidden");
        }
      }
    });
  }

  handleClick(event) {
    if (event.target.classList.contains("add")) {
      var duoField = event.target.closest(".duo-field");

      if (duoField) {
        var clonedDuoField = duoField.cloneNode(true);
        // Remove the 'hidden' class from the remove button in the cloned element
        var removeButton = clonedDuoField.querySelector(".remove");
        removeButton.classList.remove("hidden");

        duoField.parentNode.insertBefore(clonedDuoField, duoField.nextSibling);
        this.updateAllAttributes();
      }
    } else if (event.target.classList.contains("remove")) {
      var duoField = event.target.closest(".duo-field");

      if (duoField) {
        duoField.remove();
        this.updateAllAttributes();

        // If there's only one row remaining, add the 'hidden' class to the remove button
        const duoFields = document.querySelectorAll(
          `.duo-field[data-id="${this.dataset.id}"]`
        );
        if (duoFields.length === 1) {
          var removeButton = duoFields[0].querySelector(".remove");
          removeButton.classList.add("hidden");
        }
      }
    }
  }
}

customElements.define("duo-field", DuoField);

document.addEventListener("DOMContentLoaded", function () {
  const datepicker = new AirDatepicker('#datepicker', {
    dateFormat: 'MM/dd/yyyy',
    autoClose: true,
    locale: {
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'Today',
      clear: 'Clear',
      dateFormat: 'MM/dd/yyyy',
      timeFormat: 'hh:mm aa',
      firstDay: 0
    }
  });

  const checkbox = document.getElementById("dynamic-form-checkbox");
  const button = document.getElementById("form-submit-button"); // replace with your button selector

  if (checkbox && button) {
    checkbox.addEventListener("change", function () {
      button.disabled = !this.checked;
    });
  }
});
